/**
 * @file Contributor dashboard UI — pages/Dashboard/Contributor/DataInput/components/DataCollectionGuideLink.tsx.
 */

import React from "react";
import { DATA_COLLECTION_GUIDE } from "../dataCollectionGuide";

interface DataCollectionGuideLinkProps {
  className?: string;
  label?: string;
}

const DataCollectionGuideLink: React.FC<DataCollectionGuideLinkProps> = ({
  className,
  label = DATA_COLLECTION_GUIDE.label,
}) => (
  <a
    className={className}
    href={DATA_COLLECTION_GUIDE.href}
    download={DATA_COLLECTION_GUIDE.downloadName}
    target="_blank"
    rel="noopener noreferrer"
  >
    {label}
  </a>
);

/** React component — Data Collection Guide Link. */
export default DataCollectionGuideLink;
